import axiosApi from "../axiosInstance";

const getUserWiseCompanies = async (userId) => {
    try {
        const response = await axiosApi.post(`/UserCompany/GetUserWiseCompanies/${userId}`);
        return response?.data;
    } catch (error) {
        console.log("Error getUserWiseCompanies===>:", error);
        return error?.response?.data;
    }
};

const getUserWiseAssignedCompanies = async (userId) => {
    try {
        let applicationId = 19;
        const response = await axiosApi.post(`/UserCompany/GetUserWiseAssignedCompanies/${userId}/${applicationId}`);
        return response?.data;
    } catch (error) {
        console.log("Error getUserWiseAssignedCompanies===>:", error);
        return error?.response?.data;
    }
};

const addEditUserCompany = async (body) => {
    try {
        const response = await axiosApi.post(`/UserCompany/AddEditUserCompany`, body);
        return response?.data;
    } catch (error) {
        console.log("Error addEditUserCompany===>:", error);
        return error?.response?.data;
    }
};


export const UserCompanyService = {
    getUserWiseCompanies,
    getUserWiseAssignedCompanies,
    addEditUserCompany,
}